import React, {useState, memo, useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import { Toaster } from 'react-hot-toast';
import { CSSTransition } from "react-transition-group";
import "./DashboardProj.scss";
import { ReactComponent as Control} from "static/icons/double-right.svg";

import DashboardInfoTable from "components/DashboardInfoTable";
import EditorSection from "components/EditorSection";
import { ElementsAction, switchTab } from "../../store/actions/table";
import {useDashboardState} from "../../components/DashboardContext";
import QuickInfoScore from "../../components/QuickInfoScore";
import LoaderWindow from "../../components/uiComponents/LoaderWindow";
import ScoreWindow from "../../components/uiComponents/ScoreWindow";
import { resetModel } from "../../store/actions/modal";
import { setCurrentProjectAction } from "store/actions/currentProject";

const DashboardProj = ({
  location,
}) => {

  const dispatch = useDispatch();
  const tabs = useRef();
  const tabsWrapper = useRef();
  const scrollStep = 200;

  const {
    table,
    viewer: {
      quickCounterData,
      score
    }
  } = useSelector((state) => state);

  const currentProject = useSelector((state) => state.currentProject.project)

  useEffect(() => {
    if (!currentProject) {
      const localStorageCurrentProject =  JSON.parse(localStorage.getItem('currentProject'))
      dispatch(setCurrentProjectAction(localStorageCurrentProject))
    }else {
      localStorage.setItem('currentProject', JSON.stringify(currentProject))
    }
  }, [dispatch, currentProject])

  const { setIsTableHidden } = useDashboardState();

  const [sidebarIsOpened, setSidebarIsOpened] = useState(true);
  const [activeTab, setActiveTab] = useState(null);
  const [activeLeftControl, setActiveLeftControl] = useState(false);
  const [activeRightControl, setActiveRightControl] = useState(false);
  const [quickInfoScore, setQuickInfoScore] = useState(false);



  useEffect(() => {
    const tabsEl = tabs.current;
    const tabsWrapperEl = tabsWrapper.current;

    if(tabsEl.scrollWidth > tabsWrapperEl.scrollWidth &&
      tabsEl.scrollWidth - tabsEl.scrollLeft !== tabsEl.clientWidth) {
      setActiveRightControl(true);
    } else {
      setActiveRightControl(false);
    }
    if(tabsEl.scrollLeft > 0) {
      setActiveLeftControl(true);
    } else {
      setActiveLeftControl(false);
    }
  }, [table.tabs.length])

  useEffect(() => {
    table?.tabs.forEach((tab) => {
      if(tab?.active) {
        setActiveTab(tab);
      }
    })

    if(!table.tabs.length) {
      setIsTableHidden(true);
      dispatch(ElementsAction(null));
    }
  }, [table, table?.active]);


  useEffect(() => {
    return () => {
      dispatch(resetModel());
    };
  }, []);

  const handleActiveTab = (id) => {
    dispatch(switchTab(id));
  };

  const nextTab = () => {
    const tabsEl = tabs.current;

    tabsEl.scroll(tabsEl.scrollLeft + scrollStep, 0);

    if(tabsEl.scrollWidth - tabsEl.scrollLeft === tabsEl.clientWidth) {
      setActiveRightControl(false);
    }
    if(tabsEl.scrollLeft !== 0) {
      setActiveLeftControl(true);
    }
  };

  const prevTab = () => {
    const tabsEl = tabs.current;

    tabsEl.scroll(tabsEl.scrollLeft - scrollStep, 0);

    if(tabsEl.scrollLeft === 0) {
      setActiveLeftControl(false);
    }
    if(tabsEl.scrollWidth - tabsEl.scrollLeft !== tabsEl.clientWidth) {
      setActiveRightControl(true);
    }
  };

  const managerQuickInfoScore = (value) => {
    setQuickInfoScore(value);
  };

  return (
    <div className="dashboard-proj">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            maxWidth: '480px',
            margin: 0,
            padding: 0,
            borderRadius: '20px',
          },
        }}
      />

      <div className="main">
        {
          quickInfoScore && <QuickInfoScore quickScore={score} managerQuickInfoScore={managerQuickInfoScore}/>
        }
        <div className={`main-dashboard ${table.colapsedDash}`}>
          <EditorSection
            autodesk={window.Autodesk}
            projectData={location.state.project}
            quickCounterData={quickCounterData}
            table={table}
            sidebarIsOpened={sidebarIsOpened}
          />
          <div className="tabs-wrapper" ref={tabsWrapper}>
            {
              activeLeftControl &&
              <div className="tabs-control left-control" onClick={prevTab}><Control /></div>
            }
            <div className="tabs" ref={tabs}>
                {
                  table.tabs.map((tab) => {

                    return (
                        <div key={tab.title}
                             className={`tab ${activeTab?.id === tab.id && "tab-active"}`}
                             onClick={()=> handleActiveTab(tab.id)}>
                          <span className="tab__text">{tab.title}</span>
                        </div>
                    )
                  })
                }
            </div>
            {
              activeRightControl &&
              <div className="tabs-control right-control" onClick={nextTab}><Control /></div>
            }
          </div>
          {activeTab &&  <DashboardInfoTable table={activeTab} />}
        </div>
        {
          (typeof score === 'number' && !quickInfoScore) && <ScoreWindow managerQuickInfoScore={managerQuickInfoScore} score={score}/>
        }
        <CSSTransition
          in={typeof score !== 'number'}
          timeout={150}
          unmountOnExit
          classNames="animation"
        >
          <div className="dashboard-proj__preloader">
            <LoaderWindow />
          </div>
        </CSSTransition>
      </div>
    </div>
  );
};

export default memo(DashboardProj);
